module.exports = __webpack_public_path__ + "media/images/svg/tick-v2-fcd8793edefba40d8bfa01437351234f.svg";